import { FormInput } from '../../../../../../component/input/InputStyle';
import FormLabel from '../../../../../../component/input/FormLabel.component';
import { ChangeEvent, useState } from 'react';
import useDebounce from '../../../../../../hooks/useDebounce';
import {FormInterfaceFilter} from '../../../../../../core/interfaces/form/Form';
import { Grid } from '@material-ui/core';
import { InterfaceStore } from '../../interface/InterfaceStore';

export default function FormFilter({handleSubmitForm}: FormInterfaceFilter<InterfaceStore>) {

    const debounce = useDebounce(handleSubmitForm, 400);

    const [values, setValues] = useState({
        destino: '',
        tipoVeiculo: '',
       });

    const handleChange = (event: ChangeEvent<HTMLInputElement>) => {
        const { value, name } = event.target;
        setValues({ ...values, [name]: value });
        debounce({ ...values, [name]: value });
    }

    return (
        <>
                <Grid style={{display: 'flex', marginBottom: '10px', justifyContent: 'space-between'}}>
                        <FormLabel title="Loja" sm={3} md={3} lg={3}>
                            <FormInput
                                name="destino"
                                value={values.destino}
                                onChange={handleChange}
                            />
                        </FormLabel>   
                    <FormLabel title="Tipo de Caminhão" sm={6} md={6} lg={6} >
                        <FormInput
                            name="tipoVeiculo"
                            value={values.tipoVeiculo}
                            onChange={handleChange}
                        />
                    </FormLabel>
                </Grid>
        </>
    )
}